import { FC } from 'react';
import { Chip as MuiChip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { IconX } from '@tabler/icons-react';

import { ChipProps } from './types';

const Chip: FC<ChipProps> = ({
  backgroundColor,
  chipRef,
  color,
  component,
  disabled,
  fontSize,
  hoverColor,
  label,
  onClick,
  onDelete,
  shouldStopMouseDownPropagation,
  size,
  startAdornment,
  sx,
  value,
  variant,
}) => {
  const { palette } = useTheme();
  const gradientBackground =
    variant === 'gradient-blue'
      ? 'linear-gradient(270deg, #BD00FF 5.08%, #3866F5 94.92%)'
      : 'linear-gradient(270deg, #EC4A77 0%, #FF70C6 100%)';
  return (
    <MuiChip
      ref={chipRef}
      icon={startAdornment}
      sx={[
        {
          '& .MuiChip-deleteIcon': {
            '&:hover': {
              color: palette.colors.grey[800],
            },
            color: palette.colors.grey[700],
          },
          '& .MuiChip-icon': {
            'marginLeft': '8px',
          },
          'bgcolor': variant.includes('gradient') ? null : backgroundColor,
          'borderColor': color,
          'color': color,
          'fontSize': fontSize,
        },
        variant === 'intent' && {
          '&&:hover': {
            'bgcolor': hoverColor ? hoverColor : color,
            'color': hoverColor ? null : backgroundColor,
          },
          'borderRadius': '20px',
          'transition': 'all 150ms ease-in-out 100ms',
        },
        (variant === 'intent' || variant === 'outlined') && {
          borderColor: palette.colors.grey[500],
        },
        variant.includes('gradient') && {
          background: gradientBackground,
        },
        ...(Array.isArray(sx) ? sx : [sx ?? {}]),
      ]}
      variant={
        variant === 'intent'
          ? 'outlined'
          : variant === 'gradient-blue' || variant === 'gradient-pink'
            ? 'filled'
            : variant
      }
      onDelete={onDelete ? e => onDelete(e, value ?? label) : undefined}
      onMouseDown={
        onDelete && shouldStopMouseDownPropagation
          ? e => {
              e.stopPropagation();
            }
          : undefined
      }
      deleteIcon={
        <IconX fill={palette.colors.black} size={20} strokeWidth={2} />
      }
      {...{ component, disabled, label, onClick, size }}
    />
  );
};

export default Chip;
